import ScheduleViewVisits from "./Visits";

import { ReactComponent as PlusIcon } from 'icons/buttons/plus.svg';

export default class ScheduleViewDoctors extends ScheduleViewVisits {

    docResizeStart(flag, info, e) {
        if (e.button !== 0)
            return;

        const { doctorIdDate, originalBeginTime, originalEndTime } = info;

        this._helper.stopEvent(e);

        this.clearDocResize();

        const node = this.doctorsNodes[doctorIdDate];
        node.vStartD = this._helper.date.fromStr(originalBeginTime);
        node.vEndD = this._helper.date.fromStr(originalEndTime);

        node.vStartLast = this._helper.date.create(node.vStartD);
        node.vEndLast = this._helper.date.create(node.vEndD);

        this._helper.dom.style(node, "zIndex", 10);

        this.resizeDocCnt = this._helper.on(window, "mousemove", this.docResizeMove.bind(this, flag, info, node));
        this.resizeDocEndCnt = this._helper.on(window, "mouseup", this.docResizeEnd.bind(this, info, node));
        this.startY = e.pageY;
    }

    clearDocResize() {
        this._helper.disconnect(this.resizeDocCnt);
        this._helper.disconnect(this.resizeDocEndCnt);
        this.resizeDocCnt = null;
    }

    docResizeMove(flag, info, node, e) {
        const { start, end } = info;
        const { pageY } = e;
        const diffY = this.startY - pageY;

        const pxInInt = this.intPx * 5 / this.timeMins;
        const top = this._helper.number.roundByFloor(diffY, pxInInt) / this.intPx;
        let mins = this._helper.number.roundBy(top * this.timeMins, 5);

        let startDCopy = new Date(node.vStartD.getTime());
        let endDCopy = new Date(node.vEndD.getTime());

        if (flag === -1 || flag === 2)
            startDCopy.setMinutes(startDCopy.getMinutes() - mins);
        if (flag > 0)
            endDCopy.setMinutes(endDCopy.getMinutes() - mins);

        const diffMins = (endDCopy.getTime() - startDCopy.getTime()) / this._helper.date.msInMinute;

        let from = this.getPercentFromTimes(start, startDCopy);
        let size = this.getPercentFromTimes(startDCopy, endDCopy);

        const diffTimeEnd = this._helper.date.diffTime(end, endDCopy);

        if (from < 0 || diffTimeEnd < 0 || diffMins < 5 || node.vStartD.getDate() !== startDCopy.getDate() || node.vEndD.getDate() !== endDCopy.getDate())
            return;

        let intersect = false;

        node.parentNode.querySelectorAll(".doctor").forEach(n => {
            if (n === node)
                return;

            const stD = this._helper.date.fromStr(n.dataset.beginDateTime);
            const endD = this._helper.date.fromStr(n.dataset.endDateTime);

            if (node.vStartD.getTime() < stD.getTime() && endDCopy.getTime() > stD.getTime()) {
                intersect = true;
            }
            if (node.vEndD.getTime() > endD.getTime() && startDCopy.getTime() < endD.getTime()) {
                intersect = true;
            }
        });

        if (intersect)
            return;

        node.querySelectorAll(".visit").forEach(n => {
            const stD = this._helper.date.fromStr(n.dataset.beginDate);
            const endD = this._helper.date.fromStr(n.dataset.endDate);

            if (stD.getTime() < startDCopy.getTime()) {
                intersect = true;
                startDCopy = stD;
            }
            if (endD.getTime() > endDCopy.getTime()) {
                intersect = true;
            }

            if (!intersect)
                this._helper.dom.styleProp(n, "start", this.getPercentFromTimes(startDCopy, stD));
        });

        if (intersect)
            return;

        node.vTooltipText = this._helper.date.toTimeStr(startDCopy) + "-" + this._helper.date.toTimeStr(endDCopy);
        this._helper.showTooltip(node);

        this._helper.dom.styleProp(node, "from", from);
        this._helper.dom.styleProp(node, "size", size);

        node.vStartLast = startDCopy;
        node.vEndLast = endDCopy;
    }

    docResizeEnd(info, node) {
        this.clearDocResize();

        this._helper.dom.style(node, "zIndex", "");

        this._helper.hideTooltip();

        if (node.vStartLast.getTime() === node.vStartD.getTime() && node.vEndLast.getTime() === node.vEndD.getTime())
            return;

        const beginDate = this._helper.date.toStr(node.vStartLast);
        const endDate = this._helper.date.toStr(node.vEndLast);

        this.updateDoctorSh(info.shId, { beginDate, endDate });
        //this.updateDoctorSh(info.parent?.id, { beginDate, endDate });

        const { from, size } = info;

        this._helper.dom.styleProp(node, "from", from);
        this._helper.dom.styleProp(node, "size", size);
    }

    onMouseMoveDoctor(from, startDateStr, endDateStr, currentTime, visitsTimes, e) {
        if (this.resizeCnt)
            return;

        const node = e.currentTarget;
        const newNode = node.querySelector(".newApp");
        const isNewNode = this._helper.dom.isChildOf(e.target, newNode);
        const show = e.currentTarget === e.target || isNewNode;
        this._helper.dom.addRemoveClass(node, "hover", show);

        if (show) {
            const startDate = this._helper.date.create(startDateStr);
            const endDate = this._helper.date.create(endDateStr);

            const pxInInt = this.intPx * 5 / this.timeMins;
            const top = this._helper.number.roundByFloor(e.nativeEvent.offsetY, pxInInt) / this.intPx;
            const mins = top * this.timeMins;
            const d = new Date(startDate.getTime());
            d.setMinutes(d.getMinutes() + Number(mins.toFixed(2)));

            this._helper.dom.styleProp(newNode, "top", top);
            this._helper.dom.styleProp(this.timeLinePointer, "from", top + from);

            this.timeLinePointerLabel.innerText = this._helper.date.toTimeStr(d);

            const endD = new Date(d.getTime());
            let endMins = endD.getMinutes();
            if (this.isFullDay)
                endMins += 60;

            endD.setMinutes(endMins + this.timeMins);

            const sds = this._helper.date.fromStr(startDateStr);
            const eds = this._helper.date.fromStr(endDateStr);
            const dateInRange = this._helper.date.dateInRange(d, sds, eds);

            if (!dateInRange)
                return;

            if (endD.getTime() > endDate.getTime()) {
                this.hideHover(node);
                return;
            }

            let conflictingVisit = null;

            for (const visit of visitsTimes) {
                if (visit.beginTime < endD.getTime() && visit.endTime > d.getTime()) {
                    this.hideHover(node);
                    conflictingVisit = visit;
                    break;
                }
            }

            if (conflictingVisit) {
                const beginTimeDate = this._helper.date.create(conflictingVisit.beginTime);
                let i = 0;
                while (i < 10 && ((beginTimeDate - endD) / 60000) < 5) {
                    endD.setMinutes(endD.getMinutes() - 15);
                    i++;
                }
            }

            if (endD - d < 1)
                return;

            this.timeLinePointerLabel.vTime = d;
            this.timeLinePointerLabel.vTimeEnd = endD;
        } else
            this.hideHover(node);
    }

    onMouseLeaveDoctor(e) {
        this.hideHover(e.currentTarget);
    }

    hideHover(docNode) {
        this._helper.dom.removeClass(docNode, "hover");
        this._helper.dom.styleProp(this.timeLinePointer, "from", -1);

        this.timeLinePointerLabel.vTime = null;
        this.timeLinePointerLabel.vTimeEnd = null;
        this.timeLinePointerLabel.innerText = "";
    }

    async updateDoctorSh(id, info) {
        this._helper.showLoading();

        const infoShed = await this._request.doctorsSchedule.getScheduleByParentId(id);
        if (infoShed?.data) {
            const { repeatType } = infoShed?.data[0];

            if (repeatType === "WEEKLY") {
                this._helper.hideLoading();
                this._helper.showNotifyPopup({
                    type: "error",
                    label: this.tr("Ошибка обновления расписания"),
                    text: this.tr('Данная смена является регулярной, правку данной смены можете осуществить из меню "Расписание"'),
                });
                this.props.refreshVisits();
            } else {
                const beginTime = this._helper.date.toTimeStr(this._helper.date.toUtc(info.beginDate), false);
                const endTime = this._helper.date.toTimeStr(this._helper.date.toUtc(info.endDate), false);
                const beginDate = this._helper.date.toDateServerStr(info.beginDate);
                const endDate = beginDate;

                await this._request.doctorsSchedule.update(id, { beginTime, endTime, beginDate, endDate });
                this._helper.hideLoading();
                this.props.getSchedules();
            }
        }

    }

    openAddVisit(domainId, cabinetId, assistantId, doctorId, currentClient) {
        const { stageId, forClientId } = this.props;
        const beginDate = this.timeLinePointerLabel.vTime;
        const endDate = this.timeLinePointerLabel.vTimeEnd;

        let client = null;
        if (currentClient) {
            const clients = this._helper.storage("apptSelectedClients")?.items || [];
            client = clients.find(cl => cl.id === currentClient) || null;
        }

        if (beginDate && endDate && doctorId)
            this.props.openAddVisit({ domainId, cabinetId, assistantId, doctorId, beginDate, endDate, stageId, forClientId }, client, this.props.refreshVisits);
    }

    onDragOver(info, startDateStr, e) {
        const startDate = this._helper.date.create(startDateStr);
        const pxInInt = this.intPx * 5 / this.timeMins;
        const top = this._helper.number.roundByFloor(e.nativeEvent.offsetY, pxInInt) / this.intPx;
        const mins = top * this.timeMins;
        const d = new Date(startDate.getTime());
        d.setMinutes(d.getMinutes() + Number(mins.toFixed(2)));

        this.timeLinePointerLabel.vTime = e?.nativeEvent?.target?.className?.includes("doctor") ? d : "ban";

        e.preventDefault();
    }

    onShowError(text) {
        this._helper.showNotifyPopup({
            type: "error",
            label: this.tr("Ошибка обновления расписания"),
            text,
        });
    }

    showError() {
        this.onShowError(this.tr("schedule.timeCrossing"));
    }

    showError2() {
        this.onShowError(this.tr("Визит выходит за интервал расписания доктора!"));
    }

    showError3() {
        this.onShowError(this.tr("Пересечение с другим визитом"));
    }

    onDrop(info, visits) {
        const { id, beginDate, endDate, callConfirmed } = globalThis.currentDropValue;
        const { id: doctorId, cabinetId, originalBeginTime, originalEndTime } = info;

        const interval = this._helper.date.diffTime2(new Date(endDate), new Date(beginDate));
        const intervalMin = interval / 60000;

        const d = this.timeLinePointerLabel.vTime;
        if (d !== "ban") {
            const endD = new Date(d.getTime());
            let endMins = endD.getMinutes();
            /*if (this.isFullDay)
                endMins += 60;*/

            endD.setMinutes(endMins + intervalMin);

            const obj = {
                doctorId,
                cabinetId,
                beginDate: this._helper.date.toStr(d),
                endDate: this._helper.date.toStr(endD),
                status: "WI_CREATED",
                callConfirmed
            };

            for (let it of visits) {
                const { beginDate: bd, endDate: ed } = it;
                const bd2 = this._helper.date.toUtc(new Date(bd));
                const ed2 = this._helper.date.toUtc(new Date(ed));

                const intervalsOverlap = this._helper.date.intervalsOverlapTime(bd2, ed2, d, endD);
                if (intervalsOverlap) {
                    this.showError3();
                    return false;
                }
            }
            const bd = this._helper.date.toUtc(new Date(originalBeginTime));
            const ed = this._helper.date.toUtc(new Date(originalEndTime));
            const intervalExceedsBounds = this._helper.date.intervalExceedsBounds(bd, ed, d, endD);

            if (!intervalExceedsBounds)
                this.props.updateVisit(id, obj);
            else
                this.showError2();

        } else {
            this.showError();
        }
    }

    openEmployee(id) {
        this._helper.openEmployee(id);
    }

    insertDoctor(info, start, end, visits = []) {
        const { clinicId, canceledMode, currentTime, currentClient, editDoctorsMode } = this.props.info;

        const { id, originalBeginTime, originalEndTime, cabinetId, assistantId, time, createdTime } = info;
        const newDoctor = this._helper.date.isDateNotOlderThan(createdTime, 3);
        let slotNewDoctor = false;
        if (newDoctor)
            slotNewDoctor = this._helper.date.isDateNotOlderThan(createdTime, 3, originalBeginTime);

        const startDate = this._helper.date.getTimeToday(originalBeginTime);
        const endDate = this._helper.date.getTimeToday(originalEndTime);

        const from = this.getPercentFromTimes(start, startDate);
        const size = this.getPercentFromTimes(startDate, endDate);

        const eaqualVisits = {};
        const doctorIdDate = `${id}_${cabinetId}_${time}`;

        if (!this.currentDoctorVisits[doctorIdDate])
            this.currentDoctorVisits[doctorIdDate] = [];

        const moveEv = this.onMouseMoveDoctor.bind(this, from, originalBeginTime, originalEndTime, currentTime, this.currentDoctorVisits[doctorIdDate]);

        const timeLabel = this.isFullDay ? `2 ${this.tr("main.hhh")}` : this.props.timeLabel;
        const cantMoveEv = editDoctorsMode || canceledMode;
        const editCl = editDoctorsMode ? "editMode" : "";

        const editProps = { ...info, currentTime, start, end, doctorIdDate, from, size };

        let spec = "";
        if (info?.specs?.length > 0)
            spec = info.specs[0].specEntity.title;

        return (
            <div
                key={doctorIdDate}
                ref={el => this.doctorsNodes[doctorIdDate] = el}
                className={`doctor pos abs rad8 ${editCl} ${slotNewDoctor ? "new-doctor" : ""}`}
                style={{ "--from": from, "--size": size }}
                data-id={id}
                data-id-date={doctorIdDate}
                data-cabinet-id={cabinetId}
                data-begin-date-time={originalBeginTime}
                data-end-date-time={originalEndTime}
                onMouseMove={cantMoveEv ? null : moveEv}
                onDragOver={this.onDragOver.bind(this, info, originalBeginTime)}
                onDrop={this.onDrop.bind(this, info, visits)}
                onMouseLeave={cantMoveEv ? null : this.onMouseLeaveDoctor.bind(this)}
                onClick={cantMoveEv ? null : this.openAddVisit.bind(this, clinicId, cabinetId, assistantId, id, currentClient)}
                onMouseDown={!editDoctorsMode ? null : this.docResizeStart.bind(this, 2, editProps)}
            >
                <div className="mainLabel pos abs rad4 hidden hand" data-tooltip={spec} onClick={this.openEmployee.bind(this, id)}>
                    {this._helper.string.formatFullName(info, "short")}
                </div>
                <div className="newApp pos abs flex col centerAll rad8 hand">
                    <PlusIcon />
                    <div className="texts text p1SemiBold">{this.tr("main.appoint_new")}</div>
                    <div className="texts text p2">{timeLabel}</div>
                </div>
                {editDoctorsMode && (
                    <div className="pos abs resizer top" onMouseDown={this.docResizeStart.bind(this, -1, editProps)}></div>
                )}
                {editDoctorsMode && (
                    <div className="pos abs resizer bottom" onMouseDown={this.docResizeStart.bind(this, 1, editProps)}></div>
                )}
                {visits.map((it, i) => {
                    return this.insertVisit(i, id, it, { originalBeginTime, originalEndTime, eaqualVisits, currentTime, canceledMode, time });
                }
                )}
            </div>
        );
    }
}

